import { penceToPoundString } from "@/common-functions.js";

let riderData = {
  allRiderTriggers: {
    find_tracker_deposit: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Find Tracker Deposit",
      eventName: "Find Tracker Deposit",
      icon: {
        symbol: "fas fa-leaf",
        color: "#42B983",
      },
      userTrigger: true,
    },
    toggle_green_leaderboard_off: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Toggle Green Leaderboard Off",
      eventName: "Green Leaderboard",
      icon: {
        symbol: "fas fa-leaf",
        color: "#42B983",
      },
      userTrigger: true,
    },
    toggle_green_leaderboard_on: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Toggle Green Leaderboard On",
      eventName: "Green Leaderboard",
      icon: {
        symbol: "fas fa-leaf",
        color: "#42B983",
      },
      userTrigger: true,
    },
    toggle_flinta_leaderboard_off: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Toggle FLINTA Leaderboard Off",
      eventName: "FLINTA Leaderboard",
      icon: {
        symbol: "fas fa-venus-mars",
        color: "#ffc107",
      },
      userTrigger: true,
    },
    toggle_flinta_leaderboard_on: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Toggle FLINTA Leaderboard On",
      eventName: "FLINTA Leaderboard",
      icon: {
        symbol: "fas fa-venus-mars",
        color: "#ffc107",
      },
      userTrigger: true,
    },
    toggle_media_license: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Toggle Media License",
      eventName: "Media License",
      icon: {
        symbol: "fas fa-leaf",
        color: "#42B983",
      },
      userTrigger: true,
    },
    add_note: {
      formComponent: "requires-further-attention",
      verboseName: "Add Note",
      eventName: "Note",
      icon: {
        symbol: "fas fa-sticky-note",
        color: "#42B983",
      },
      userTrigger: true,
    },
    toggle_attention: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Toggle Flag",
      eventName: "Flag state toggled",
      icon: {
        symbol: "fas fa-flag",
        color: "#42B983",
      },
      userTrigger: true,
    },
    id_check: {
      formComponent: "trigger-with-volunteer",
      verboseName: "ID Check",
      eventName: "ID Check",
      icon: {
        symbol: "fas fa-check",
        color: "#42B983",
      },
      userTrigger: true,
    },
    bike_check_fail: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Bike Check FAIL",
      eventName: "Bike Check FAIL",
      icon: {
        symbol: "fas fa-ban",
        color: "#e75a7c",
      },
      userTrigger: true,
    },
    bike_check_pass: {
      formComponent: "requires-further-attention",
      verboseName: "Bike Check PASS",
      eventName: "Bike Check PASS",
      icon: {
        symbol: "fas fa-check",
        color: "#42B983",
      },
      userTrigger: true,
    },
    doesnt_start: {
      formComponent: "trigger-with-volunteer",
      verboseName: "DNS",
      eventName: "DNS",
      icon: {
        symbol: "fas fa-ban",
        color: "#e75a7c",
      },
      userTrigger: true,
    },
    scratches: {
      formComponent: "scratch",
      verboseName: "Scratch",
      eventName: "Scratched",
      icon: {
        symbol: "fas fa-ban",
        color: "#e75a7c",
      },
      userTrigger: true,
    },
    unscratches: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Un-Scratch",
      eventName: "Un-Scratched",
      icon: {
        symbol: "fas fa-tick",
        color: "#e75a7c",
      },
      userTrigger: true,
    },
    disqualifies: {
      formComponent: "disqualify",
      verboseName: "Disqualify",
      eventName: "Disqualified",
      icon: {
        symbol: "fas fa-gavel",
        color: "#e75a7c",
      },
      userTrigger: true,
    },
    undisqualifies: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Un-Disqualify",
      eventName: "Un-Disqualified",
      icon: {
        symbol: "fas fa-undo",
        color: "#42B983",
      },
      userTrigger: true,
    },
    fully_registered: {
      verboseName: "Registers",
      eventName: "Registers",
      icon: {
        symbol: "fas fa-flag-checkered",
        color: "#5c95ff",
      },
      userTrigger: false,
    },
    starts: {
      verboseName: "Starts",
      eventName: "Started",
      icon: {
        symbol: "fas fa-flag-checkered",
        color: "#5c95ff",
      },
      userTrigger: false,
    },
    finishes: {
      verboseName: "Finishes",
      eventName: "Finished",
      icon: {
        symbol: "fas fa-flag-checkered",
        color: "#42B983",
      },
      userTrigger: false,
    },
    give_tracker: {
      formComponent: "give-tracker",
      verboseName: "Give tracker",
      eventName: "Received tracker",
      icon: {
        symbol: "fas fa-sign-out-alt",
        color: "#5c95ff",
      },
      userTrigger: true,
    },
    retrieve_tracker: {
      formComponent: "retrieve-tracker",
      verboseName: "Retrieve tracker",
      eventName: "Returned tracker",
      icon: {
        symbol: "fas fa-sign-in-alt",
        color: "#5c95ff",
      },
      userTrigger: true,
    },
    lose_tracker: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Record as lost",
      eventName: "Lost tracker",
      icon: {
        symbol: "fas fa-ban",
        color: "#e75a7c",
      },
      userTrigger: false,
    },
    manual_tracker_deposit: {
      formComponent: "manual-tracker-deposit",
      verboseName: "Manual Tracker Deposit",
      eventName: "Manual Tracker Deposit",
      icon: {
        symbol: "fas fa-hand-holding",
        color: "#5c95ff",
      },
      userTrigger: true,
    },
    refund_rider: {
      formComponent: "trigger-with-volunteer",
      verboseName: "Rider Refund",
      eventName: "Rider Refund",
      icon: {
        symbol: "fas fa-undo",
        color: "#ffc107",
      },
      userTrigger: true,
    },
  },
  riderStates: {
    dns: { verboseName: "DNS", color: "secondary" },
    not_active: { verboseName: "Not active", color: "secondary" },
    registering: { verboseName: "Registering", color: "primary" },
    active: { verboseName: "Active", color: "success" },
    scratched: { verboseName: "Scratched", color: "danger" },
    finished: { verboseName: "Finished", color: "success" },
    dsq: { verboseName: "DSQ", color: "danger" },
  },
  riderInfo: {
    balance: {
      verboseName: "Balance",
      displayRepresentation: penceToPoundString,
    },
    country: { verboseName: "Country" },
    wave: {
      verboseName: "Wave",
      displayRepresentation: function (wave) {
        return wave ? wave.name : "";
      },
    },
    gender: {
      verboseName: "Gender",
      displayRepresentation: function (gender) {
        const genderLabels = {
          M: "Male",
          F: "Female",
          "Non-Binary": "Non-Binary/Genderqueer",
          "Not specified": "Not specified",
        };
        return genderLabels[gender] || gender;
      },
    },
    battery_level: {
      verboseName: "Battery Level",
      displayRepresentation: function (battery_level) {
        return battery_level ? `${battery_level}%` : "n/a";
      },
    },
    distance_covered: {
      verboseName: "Distance Covered",
      displayRepresentation: function (distance_covered) {
        return distance_covered ? `${distance_covered.toFixed(2)} km` : "n/a";
      },
    },
  },
};

export { riderData };
